export default __webpack_public_path__ + "static/oudemeer-a017237c8380c909979f00765d82fef3.webp";